const INITIAL_CONTACT_SKIPPED = 'initial_contact_skipped'

function valueCode(value) {
  if (!value) return ''
  return String(value.code || value.id || '')
}

function humanizeCode(value) {
  const normalized = String(value || '')
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
  if (!normalized) return ''
  return `${normalized.charAt(0).toUpperCase()}${normalized.slice(1)}`
}

function eventReasonName(event) {
  if (event && event.delay && event.delay.reason) return event.delay.reason
  const reason = event && event.reason
  if (!reason) return ''
  return reason.name || reason.label || humanizeCode(valueCode(reason))
}

function eventName(event) {
  if (event && event.delay) return 'Follow-up schedule delayed'
  const type = event && event.type
  return type && (type.name || type.label || type.code) ? (type.name || type.label || type.code) : ''
}

function eventNote(event) {
  const note = String((event && event.note) || '').trim()
  const type = valueCode(event && event.type)

  if (type === 'manager_assigned' && event.assignment && event.assignment.manager) {
    const assignment = event.assignment
    const target = `Manager: ${assignment.manager.name}`
    const delivery = assignment.initial_contact_enabled === false ? 'No automatic initial contact.' : ''
    return [target, delivery, note].filter(Boolean).join(' · ')
  }

  if (type === INITIAL_CONTACT_SKIPPED) {
    if (eventReasonName(event)) return ''
    return note.replace(
      /^initial contact skipped(?:\s*\([^)]*\))?\s*:\s*/i,
      ''
    ).trim()
  }

  if (['initial_contact_queued', 'initial_contact_sent'].includes(type)) {
    return note.replace(/;\s*template:.*$/i, '.')
  }

  return note
}

function deliveryProviderName(delivery) {
  const provider = String((delivery && delivery.provider) || '').toLowerCase()
  if (provider === 'whatsapp') return 'WhatsApp'
  if (provider === 'email') return 'Email'
  return humanizeCode(provider) || 'Channel'
}

function deliveryStatusName(delivery) {
  return humanizeCode(delivery && delivery.status) || 'Unknown'
}

function deliveryTone(delivery) {
  const status = String((delivery && delivery.status) || '').toLowerCase()
  if (['sent', 'accepted', 'delivered', 'read'].includes(status)) return 'green'
  if (['queued', 'pending', 'running'].includes(status)) return 'blue'
  if (['failed', 'rejected'].includes(status)) return 'red'
  if (status === 'skipped') return 'amber'
  return 'neutral'
}

function deliveryIcon(delivery) {
  const status = String((delivery && delivery.status) || '').toLowerCase()
  if (['sent', 'accepted', 'delivered', 'read'].includes(status)) return '✓'
  if (['queued', 'pending', 'running'].includes(status)) return '→'
  if (['failed', 'rejected'].includes(status)) return '×'
  if (status === 'skipped') return '!'
  return '?'
}

function deliveryMessage(delivery) {
  const message = String((delivery && delivery.message) || '').trim()
  if (message) return message
  return humanizeCode(delivery && delivery.reason)
}

module.exports = {
  deliveryIcon,
  deliveryMessage,
  deliveryProviderName,
  deliveryStatusName,
  deliveryTone,
  eventNote,
  eventName,
  eventReasonName,
  humanizeCode
}
